import http from "../index";

interface UserInfo {
	name: string;
	email: string;
}

export const subscribe = (creds: UserInfo) => http.post("/stay-connected", creds);
